import React, { useEffect, useState, useMemo } from 'react';
import './AnnouncementBannerList.scss';

const STORAGE_KEY_PREFIX = 'ANNOUNCEMENT_DISMISSED_';

function Banner({ banner, onDismiss }) {
  const { id, message, linkUrl, severity } = banner;
  const className = `announcement-banner announcement-${severity || 'info'}`;

  return (
    <div className={className} role="status" aria-live="polite">
      <div className="announcement-content">
        <div className="announcement-message">{message}</div>
        {linkUrl ? (
          <a
            className="announcement-link"
            href={linkUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn more
          </a>
        ) : null}
      </div>
      <button
        type="button"
        className="announcement-close"
        aria-label="Dismiss announcement"
        onClick={() => onDismiss(id)}
      >
        ×
      </button>
    </div>
  );
}

export default function AnnouncementBannerList() {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    let abort = false;
    const fetchBanners = async () => {
      try {
        const url = '/popin/api/1.0/banners';
        console.log('[Announcement] fetching', url);
        const resp = await fetch(url, {
          credentials: 'include',
          headers: { 'Accept': 'application/json' }
        });
        if (!resp.ok) {
          console.log('[Announcement] fetch error status', resp.status);
          return;
        }
        const text = await resp.text();
        // console.log('[Announcement] raw text length', text ? text.length : 0);
        // if (text) {
        //   console.log('[Announcement] raw text preview', text.substring(0, 200));
        // }
        let data = [];
        if (text && text.trim().length > 0) {
          try {
            const parsed = JSON.parse(text);
            if (Array.isArray(parsed)) {
              data = parsed;
              // console.log('[Announcement] parsed array length', data.length);
            } else if (parsed && Array.isArray(parsed.data)) {
              data = parsed.data;
              // console.log('[Announcement] parsed wrapper array length', data.length);
            } else if (parsed && Array.isArray(parsed.banners)) {
              data = parsed.banners;
              // console.log('[Announcement] parsed banners array length', data.length);
            } else if (parsed && Array.isArray(parsed.items)) {
              data = parsed.items;
              // console.log('[Announcement] parsed items array length', data.length);
            } else {
              // console.log('[Announcement] parsed shape not array', parsed && Object.keys(parsed));
            }
          } catch (e) {
            // console.log('[Announcement] parse error', e);
            data = [];
          }
        }
        if (!abort && Array.isArray(data)) {
          // console.log('[Announcement] setting banners length', data.length);
          setBanners(data);
        }
      } catch (e) {
        console.log('[Announcement] fetch exception', e);
      }
    };
    fetchBanners();
    return () => { abort = true; };
  }, []);

  const visibleBanners = useMemo(() => {
    const filtered = (banners || []).filter(b => {
      const key = STORAGE_KEY_PREFIX + b.id;
      return sessionStorage.getItem(key) !== '1';
    });
    // console.log('[Announcement] visible banners', filtered.length);
    return filtered;
  }, [banners]);

  const handleDismiss = (id) => {
    try {
      sessionStorage.setItem(STORAGE_KEY_PREFIX + id, '1');
      setBanners(prev => prev.slice()); // trigger recompute
    } catch (e) {
      console.log('Announcement dismiss storage error', e);
    }
  };

  if (!visibleBanners.length) return null;

  return (
    <div className="announcement-container">
      <div className="announcement-inner">
        {visibleBanners.map(b => (
          <Banner key={b.id} banner={b} onDismiss={handleDismiss} />
        ))}
      </div>
    </div>
  );
}
